import { EnkodProvider } from './src/enkod';

export default new EnkodProvider();
